var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotificationHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "29px",
    viewBox: "0 0 23 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNotificationHeader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notifications-SubMenu",
    transform: "translate(-1227.000000, -25.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Header",
    transform: "translate(0.000000, -62.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top-Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-top-header",
    transform: "translate(1184.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-82",
    transform: "translate(34.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BeLL_2",
    transform: "translate(9.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.023504, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.55139186,23.9101124 C-0.517130621,23.9101124 -0.517130621,20.659176 1.55139186,20.659176 C3.22591006,20.659176 3.32441113,14.3670412 3.32441113,12.164794 C3.32441113,6.92134831 6.27944325,3.88014981 9.62847966,3.14606742 C9.03747323,1.67790262 10.0224839,3.55271368e-15 11.5,3.55271368e-15 C12.9775161,3.55271368e-15 13.9625268,1.67790262 13.3715203,3.14606742 C16.7205567,3.88014981 19.6755889,6.92134831 19.6755889,12.164794 C19.6755889,14.3670412 19.7740899,20.659176 21.4486081,20.659176 C23.5171306,20.659176 23.5171306,23.9101124 21.4486081,23.9101124 L1.55139186,23.9101124 Z M13.6618383,25 C14.6226553,26.4681648 13.421634,28.3558052 11.5,28.3558052 C9.57836597,28.3558052 8.37734471,26.4681648 9.33816172,25 L13.6618383,25 Z",
    id: "icNotificationHeader"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationHeader);
export default __webpack_public_path__ + "static/media/icNotificationHeader.21d6d4b3cca63f9949125b3e5813f45c.svg";
export { ForwardRef as ReactComponent };